(function () {
  'use strict';

  function initSplideSlider(sliderEl) {
    if (!sliderEl) return;

    if (typeof window.Splide === 'undefined') {
      setTimeout(function () {
        initSplideSlider(sliderEl);
      }, 50);
      return;
    }

    // Refresh if already initialized
    if (sliderEl._splideInstance) {
      try {
        sliderEl._splideInstance.refresh();
      } catch (e) {}
      return;
    }

    var slides = sliderEl.querySelectorAll('.splide__slide');
    if (!slides.length) return;

    var prevBtn = sliderEl.querySelector('.splide__arrow--prev');
    var nextBtn = sliderEl.querySelector('.splide__arrow--next');

    var splide = new window.Splide(sliderEl, {
      type: 'slide',
      autoWidth: true,
      drag: 'free',
      snap: true,
      focus: 0,
      omitEnd: true,
      trimSpace: 'move',
      perMove: 3,
      gap: '10px',
      pagination: false,
      arrows: true,
      keyboard: false,
      wheel: false,
      padding: { left: 8, right: 14 },
      breakpoints: {
        768: {
          perMove: 2,
          padding: { left: 6, right: 12 }
        }
      }
    });

    splide.mount();
    sliderEl._splideInstance = splide;

    // Helper to get physical limits & position and update arrow disabled state
    function syncArrowStates() {
      if (!splide.Components || !splide.Components.Move) return;

      var currentPos = Math.round(splide.Components.Move.getPosition());
      var maxLimit = Math.round(splide.Components.Move.getLimit(true));
      var minLimit = Math.round(splide.Components.Move.getLimit(false));

      // Check if carousel actually has overflow (can scroll)
      var hasOverflow = Math.abs(maxLimit - minLimit) > 4;

      if (!hasOverflow) {
        if (prevBtn) {
          prevBtn.disabled = true;
          prevBtn.classList.add('is-disabled');
          prevBtn.setAttribute('disabled', 'disabled');
        }
        if (nextBtn) {
          nextBtn.disabled = true;
          nextBtn.classList.add('is-disabled');
          nextBtn.setAttribute('disabled', 'disabled');
        }
        return;
      }

      var isAtStart = currentPos >= minLimit - 2;
      var isAtEnd = currentPos <= maxLimit + 2;

      if (prevBtn) {
        prevBtn.disabled = isAtStart;
        prevBtn.classList.toggle('is-disabled', isAtStart);
        if (isAtStart) {
          prevBtn.setAttribute('disabled', 'disabled');
        } else {
          prevBtn.removeAttribute('disabled');
        }
      }

      if (nextBtn) {
        nextBtn.disabled = isAtEnd;
        nextBtn.classList.toggle('is-disabled', isAtEnd);
        if (isAtEnd) {
          nextBtn.setAttribute('disabled', 'disabled');
        } else {
          nextBtn.removeAttribute('disabled');
        }
      }
    }

    // Intercept prev click when at end to guarantee it moves back on Click 1
    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        if (!splide.Components || !splide.Components.Move) return;
        var currentPos = Math.round(splide.Components.Move.getPosition());
        var maxLimit = Math.round(splide.Components.Move.getLimit(true));

        if (currentPos <= maxLimit + 2) {
          e.preventDefault();
          e.stopImmediatePropagation();

          // Find prior slide that actually translates the carousel
          var slideItems = splide.Components.Slides.get();
          var move = splide.Components.Move;
          var targetIndex = 0;
          var step = window.innerWidth <= 768 ? 2 : 3;

          for (var i = slideItems.length - 1; i >= 0; i--) {
            var pos = Math.round(move.toPosition(i, true));
            if (pos > maxLimit + 2) {
              targetIndex = Math.max(0, i - (step - 1));
              break;
            }
          }

          splide.go(targetIndex);
          setTimeout(syncArrowStates, 50);
          setTimeout(syncArrowStates, 350);
        }
      }, true);
    }

    // Intercept next click if already at end
    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        if (!splide.Components || !splide.Components.Move) return;
        var currentPos = Math.round(splide.Components.Move.getPosition());
        var maxLimit = Math.round(splide.Components.Move.getLimit(true));

        if (currentPos <= maxLimit + 2) {
          e.preventDefault();
          e.stopImmediatePropagation();
          nextBtn.disabled = true;
          nextBtn.classList.add('is-disabled');
          nextBtn.setAttribute('disabled', 'disabled');
        }
      }, true);
    }

    // Keep arrows updated on all Splide events
    splide.on('mounted move moved dragged scroll scrolled resize refresh', function () {
      syncArrowStates();
    });

    // Auto-scroll to active swatch on mount
    function scrollToActiveSwatch() {
      var activeEl = sliderEl.querySelector(
        '.combined-product-swatches__swatch--active, .combined-product-swatches__swatch.is-active, input[type="radio"]:checked'
      );
      if (!activeEl) return;
      var slide = activeEl.closest('.splide__slide');
      if (!slide) return;

      var allSlides = Array.from(sliderEl.querySelectorAll('.splide__slide'));
      var slideIndex = allSlides.indexOf(slide);
      if (slideIndex > 0 && typeof splide.go === 'function') {
        splide.go(slideIndex);
      }
      setTimeout(syncArrowStates, 100);
    }

    // Initial sync & checks
    syncArrowStates();
    setTimeout(function () {
      if (splide.Components && splide.Components.Move) {
        splide.refresh();
      }
      syncArrowStates();
      scrollToActiveSwatch();
    }, 80);

    setTimeout(function () {
      if (splide.Components && splide.Components.Move) {
        splide.refresh();
      }
      syncArrowStates();
    }, 300);

    // When variant input changes, center active slide
    sliderEl.addEventListener('change', function (e) {
      if (e.target && e.target.matches('input[type="radio"]')) {
        setTimeout(scrollToActiveSwatch, 30);
      }
    });

    window.addEventListener('resize', function () {
      if (sliderEl._splideInstance) {
        try {
          sliderEl._splideInstance.refresh();
          syncArrowStates();
        } catch (e) {}
      }
    }, { passive: true });
  }

  function initAll() {
    if (typeof window.Splide === 'undefined') {
      setTimeout(initAll, 50);
      return;
    }
    var sliders = document.querySelectorAll('[data-color-swatches-splide]');
    sliders.forEach(initSplideSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.initColorSwatchesSliders = initAll;
  window.initColorSwatchesSlider = initSplideSlider;

  document.addEventListener('shopify:section:load', function () {
    setTimeout(initAll, 60);
  });
  document.addEventListener('variant:change', function () {
    setTimeout(initAll, 60);
  });
})();
